import axios from 'axios';
import dayjs from 'dayjs';
import { microService_url } from '../config';
import { _createCookie, _getCookie, _getFromLocalStorage } from '../helpers';

export const getAccessToken = () => {
  return _getCookie('accessToken');
};

const getRefreshToken = () => {
  return _getCookie('refreshToken');
};

const getExpiryTime = () => {
  return _getCookie('expiryDate');
};

const isValidToken = () => {
  let expiryDate = dayjs(getExpiryTime());
  let duration = expiryDate.diff(dayjs());
  if (duration > 0 && getAccessToken()) {
    return true;
  } else {
    return false;
  }
};

async function getNewAccessToken(api, originalRequest) {
  if (isValidToken()) {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + getAccessToken();
    return api(originalRequest);
  } else {
    if (!_getFromLocalStorage('rememberMe')) {
      localStorage.removeItem('phoneNumberStatus');
      //window.location.reload();
      return;
    }

    return axios
      .post(
        `${microService_url}/retailstore/api/v1.8/Login`,
        {
          RefreshToken: getRefreshToken(),
          GrantType: 'REFRESH_TOKEN',
        },
        {
          headers: { Authorization: 'Bearer ' + getAccessToken() },
        }
      )
      .then(res => {
        if (res.status === 200) {
          _createCookie('accessToken', res.data.Data.AccessToken, 63072000); //cookie expires in 2years
          _createCookie('refreshToken', res.data.Data.RefreshToken, 63072000); //cookie expires in 2years);

          _createCookie('expiryDate', res.data.Data.Expires, 63072000); //cookie expires in 2years); ///store the token expiry time in milliseconds

          api.defaults.headers.common['Authorization'] =
            'Bearer ' + res.data.Data.AccessToken;
          return api(originalRequest);
        }
      });
  }
}

// For common config
axios.defaults.headers.post['Content-Type'] = 'application/json';

export const retailSettingsApi = axios.create({
  baseURL: `${microService_url}/retailsettings/api/`,
});

export const retailLogApi = axios.create({
  baseURL: `${microService_url}/retaillog/api/`,
});

export const retailOrderApi = axios.create({
  baseURL: `${microService_url}/retailorder/api/`,
});

export const retailStoreApi = axios.create({
  baseURL: `${microService_url}/retailstore/api/`,
});

export const retailNotificationApi = axios.create({
  baseURL: `${microService_url}/notification/api/`,
});

export const retailPaymentApi = axios.create({
  baseURL: `${microService_url}/retailpayment/api/`,
});

// retailSettings Interceptors
retailSettingsApi.interceptors.request.use(
  config => {
    if (getAccessToken()) {
      retailSettingsApi.defaults.headers.common['Authorization'] =
        'Bearer ' + getAccessToken();
    }
    return {
      ...config,
    };
  },
  error => {
    Promise.reject(error);
  }
);

retailSettingsApi.interceptors.response.use(
  response => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      return await getNewAccessToken(retailSettingsApi, originalRequest);
    }
    return Promise.reject(error);
  }
);

// //retail order interceptor
retailOrderApi.interceptors.request.use(
  config => {
    if (getAccessToken()) {
      config.headers['Authorization'] = 'Bearer ' + getAccessToken();
    }
    return {
      ...config,
      // cancelToken: new retailOrderCancelToken((cancel) =>
      //   cancel("Cancelled repeated request")
      // ),
    };
  },
  error => {
    Promise.reject(error);
  }
);

retailOrderApi.interceptors.response.use(
  response => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      return await getNewAccessToken(retailOrderApi, originalRequest);
    }
    return Promise.reject(error);
  }
);

//retailStore Interceptors
retailStoreApi.interceptors.request.use(
  config => {
    if (getAccessToken()) {
      config.headers['Authorization'] = 'Bearer ' + getAccessToken();
    }
    return {
      ...config,
    };
  },
  error => {
    Promise.reject(error);
  }
);

retailStoreApi.interceptors.response.use(
  response => {
    return response;
  },
  async function (error) {
    let originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      return await getNewAccessToken(retailStoreApi, originalRequest);
    }

    return Promise.reject(error);
  }
);
//retailNotification Interceptors
retailNotificationApi.interceptors.request.use(
  config => {
    if (getAccessToken()) {
      config.headers['Authorization'] = 'Bearer ' + getAccessToken();
    }
    return {
      ...config,
    };
  },
  error => {
    Promise.reject(error);
  }
);

retailNotificationApi.interceptors.response.use(
  response => {
    return response;
  },
  async function (error) {
    let originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      return await getNewAccessToken(retailNotificationApi, originalRequest);
    }
    return Promise.reject(error);
  }
);
